export default "__VITE_ASSET__DGDk7Q$C__"